import * as React from "react";
import { AddressLookupContainer } from "../../../../containers/modules/AddressLookup/containers/AddressLookupContainer.js";
const AddressLookup = (props) => /* @__PURE__ */ React.createElement(AddressLookupContainer, { ...props });
export {
  AddressLookup
};
//# sourceMappingURL=AddressLookup.js.map
